import axios from "axios";
import { API_BASE_URL } from "../../config";

export const availabilityModeForUser = (userModes, selectedUser) =>
  userModes?.[selectedUser] === "availability" ? "availability" : "absence";

export const weekEndpointForMode = (mode) =>
  mode === "availability"
    ? `${API_BASE_URL}/api/web/availability/week`
    : `${API_BASE_URL}/api/web/absence/week`;

export const fetchAvailabilityContext = (token) =>
  axios.get(`${API_BASE_URL}/api/web/availability/context`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const fetchAvailabilityCalendar = (token, params = {}) =>
  axios.get(`${API_BASE_URL}/api/web/availability/calendar`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

export const fetchAvailabilityOverview = (token, params = {}) =>
  axios.get(`${API_BASE_URL}/api/web/availability/overview`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

export const fetchAvailabilityExportPreview = (token, params = {}) =>
  axios.get(`${API_BASE_URL}/api/web/availability/export/preview`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

export const exportAvailabilityFile = (token, payload = {}) =>
  axios.post(`${API_BASE_URL}/api/web/availability/export`, payload, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });

// Compatibility for the archived Availability implementation.
export const exportAvailabilityExcel = exportAvailabilityFile;

export const putAvailabilityDay = (token, params = {}, payload = {}) =>
  axios.put(`${API_BASE_URL}/api/web/availability/day`, payload, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

export const putAvailabilityDefaults = (token, payload = {}, params = {}) =>
  axios.put(`${API_BASE_URL}/api/web/availability/defaults`, payload, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

export const putAvailabilitySettings = (token, params = {}, payload = {}) =>
  axios.put(`${API_BASE_URL}/api/web/availability/settings`, payload, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

export const deleteAvailabilityDay = (token, params = {}, payload = {}) =>
  axios.delete(`${API_BASE_URL}/api/web/availability/day`, {
    params,
    data: payload,
    headers: { Authorization: `Bearer ${token}` },
  });

export const applyAvailabilityWeek = (token, params = {}, payload = {}) =>
  axios.post(`${API_BASE_URL}/api/web/availability/week-apply`, payload, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

// Eigene offene Verfügbarkeits- und Ferienanfragen (Mitarbeitenden-Ansicht, nur lesen).
export const fetchOwnPendingApprovals = (token) =>
  axios.get(`${API_BASE_URL}/api/web/approval/mine`, {
    headers: { Authorization: `Bearer ${token}` },
  });
